//# sourceMappingURL=list.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/list/list.interface.js
// module id = 1176
// module chunks = 4